import { resolveOption } from 'unitData/options/optionResolution';
import { MenuItem, FormControl, TextField } from '@mui/material';
import * as S from '../containers/PropertyPanel/PropertyPanel.styles';

interface DropdownInterface {
  value: string;
  setValue(val: string): void;
  dropDownOptions: (string | { value: string; label: string })[] | undefined;
  customDropDownOption?: string;
  label: string;
  marginRight?: number;
  preOptionText?: string;
  postOptionText?: string;
  postOptionTexts?: string[] | undefined;
  disabled?: boolean;
  size?: number;
}

export const Dropdown = ({
  value,
  setValue,
  label,
  marginRight,
  dropDownOptions,
  customDropDownOption,
  preOptionText,
  postOptionText,
  postOptionTexts,
  disabled,
  size,
}: DropdownInterface) => {
  const options = dropDownOptions?.map((option) =>
    typeof option === 'string' ? { value: option, label: option } : option,
  );

  const selection = resolveOption(options, value);
  // `undefined` means options are still loading; an empty array is a loaded
  // catalog with no valid choices.
  const optionsLoading = dropDownOptions === undefined;
  const unavailable =
    !optionsLoading &&
    selection.status === 'unavailable' &&
    value !== customDropDownOption;
  const selectValue =
    !optionsLoading || value === customDropDownOption ? value : '';

  return (
    <S.FormWrapper spaceRight={marginRight} size={size}>
      <FormControl variant='filled' fullWidth>
        <TextField
          label={label}
          select
          variant='filled'
          value={selectValue}
          disabled={disabled}
          fullWidth
          onChange={(e) => setValue(e.target.value.toString())}
          color='info'
        >
          {unavailable && (
            <MenuItem value={value} disabled>
              {selection.label}
            </MenuItem>
          )}
          {customDropDownOption && (
            <MenuItem value={customDropDownOption}>
              {customDropDownOption}
            </MenuItem>
          )}
          {options?.map((option, index) => {
            if (!(typeof postOptionTexts === 'undefined')) {
              const optionText = `${option.label} ${postOptionTexts?.[index] ?? ''}`;
              return (
                <MenuItem key={`${label}-${option.value}`} value={option.value}>
                  {optionText}
                </MenuItem>
              );
            } else {
              const optionText = `${preOptionText ?? ''}${option.label}${
                postOptionText ? ` ${postOptionText}` : ''
              }`;
              return (
                <MenuItem key={`${label}-${option.value}`} value={option.value}>
                  {optionText}
                </MenuItem>
              );
            }
          })}
        </TextField>
      </FormControl>
    </S.FormWrapper>
  );
};
